export default function isMobileBrowser() {
  if (typeof window === 'undefined') {
    return false;
  }

  return /(android|iphone|ipad)/i.test(window.navigator.userAgent);
}
